import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { EGetAlertsActions } from '@eview/core/store/actions/get-alerts.actions';
import { initialLinkedPostsState } from '@eview/core/store/states/linked-posts.state';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'multi-select-dropdown',
  templateUrl: 'multi-select-dropdown.component.html',
  styleUrls: ['multi-select-dropdown.component.scss']
})
export class MultiSelectDropdownComponent implements OnInit {
  @Input() list: any[];
  @Output() shareCheckedList = new EventEmitter();

  showDropDown: boolean = false
  checkedList: any[];

  constructor(private actions$: Actions) {
    this.checkedList = [];
  }

  ngOnInit() {
    this.actions$
      .pipe(ofType(EGetAlertsActions.GetAlertsSuccess))
      .subscribe(() => {
        this.checkedList = [];
        this.initList();
      });

    this.initList();

  }
  getSelectedValue(event: any, obj: any) {
    const objIndex = this.list.findIndex(x => x.id === obj.id);
    
    if (event.target.checked) {
      this.list[objIndex] = { ...this.list[objIndex], checked: true };
      this.checkedList.push(this.list[objIndex]);
    } else {
      this.list[objIndex] = { ...this.list[objIndex], checked: false };
      const index = this.checkedList.findIndex(x => x.id === obj.id);
      this.checkedList.splice(index, 1);
    }

    //share checked list
    this.shareCheckedlist();

    // this.showDropDown = false
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Check if the click event is outside the dropdown
    const targetElement = event.target as Element;
    if (!targetElement.closest('.drop-toggle') && !targetElement.closest('.drop-show')) {
      this.showDropDown = false; // Close the dropdown if clicked outside
    }
  }

  stopPropagation(event: MouseEvent) {
    event.stopPropagation(); // Prevent the click event from bubbling up to the document
  }

  initList() {
    if (this.list && this.list.length) {
      this.list = this.list.map(object => ({
        ...object,
        checked: false
      }));
    }
  }

  removePill(obj) {
    var index = this.checkedList.findIndex(x => x.id === obj.id);
    this.checkedList.splice(index, 1);
    var indexInMainList = this.list.findIndex(x => x.id === obj.id);
    this.list[indexInMainList] = { ...this.list[indexInMainList], checked: false };
    this.shareCheckedlist();
  }
  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }
}
